module.exports = __webpack_public_path__ + "images/bfp3a87e8cf3218a035d553ac20911fbe26.png";